"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _roundConstants = _interopRequireDefault(require("./round-constants"));

var _xor = _interopRequireDefault(require("../xor"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

var iota = function iota(_ref) {
  var A = _ref.A,
      roundIndex = _ref.roundIndex;
  (0, _xor.default)(A, 0)(A, 0, _roundConstants.default, roundIndex);
};

var _default = iota;
exports.default = _default;